import Vue from 'vue';
import axios from 'axios'
import {Notify, Dialog} from 'vant'
import router from '@/router'
import {getCookie, setCookie} from '@/utils/auth'

Vue.use(Notify).use(Dialog)

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_URL,
    // 超时
    timeout: 2000000
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (getCookie('token')) {
            // 让每个请求携带自定义token 请根据实际情况自行修改
            config.headers['Token'] = getCookie('token')
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// 响应拦截器
// 修复多个接口请求时, 登录超时会弹出多个弹框问题
service.interceptors.response.use(
    res => {
        const code = res.data.code
        const isLoginPath = window.location.pathname === '/login'
        /**
         * 错误编码 为 401、1003 且 msgBoxNum == 0 (没有出现过提示重新登录的弹框)
         */
        if ((code === 401 || code === 1003) && !isLoginPath) {
            Dialog.confirm({
                title: '提示',
                message: '需要先登录，才能继续操作',
                showCancelButton: true
            }).then(() => {
                setCookie('userInfo', '')
                setCookie('token', '')
                router.push("/auth")
            }).catch(() => {
                router.go(-1)
            });
            return Promise.reject('error')
        } else if (code !== 1) {
            if ((code === 401 || code === 1003)) {
                Dialog.confirm({
                    title: '提示',
                    message: res.data.message || res.data.msg,
                    showCancelButton: true
                }).then(() => {
                    setCookie('userInfo', '')
                    setCookie('token', '')
                    router.push("/auth")
                }).catch(() => {
                    router.go(-1)
                });
            } else {
                Dialog.confirm({
                    title: '提示',
                    message: res.data.message || res.data.msg,
                    showCancelButton: true
                }).then(() => {
                    setCookie('userInfo', '')
                    setCookie('token', '')
                    router.push("/auth")
                }).catch(() => {
                    router.go(-1)
                });
            }

            return Promise.reject(res)
        } else {
            return res
        }
    }, error => {
        Notify({type: 'danger', message: error.message});
        return Promise.reject(error)
    }
)

export default service
